import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
    IPStudentGradeValidationError,
    Student,
    StudentGradeValidation,
    StudentGradeValidationError
} from '../../../../shared/interface/roster.interface';
import { RosterService } from '../../../../shared/roster.service';
import { GradeValidationService } from '../../../../shared/grade-validation.service';
import {
    GradePostCompleteStatus,
    GradeValidationStatus,
    GradeValidationStatusDetail,
    GradeValidationStatusDetailList,
    IPGradeValidationStatus
} from '../../../../shared/interface/grade-validation.interface';
import { GradePostTransactionIdService } from '../../../../shared/services/grade-post-transaction-id.service';
import { IPCourseSubmit } from '../../../../shared/interface/ip-grading.interface';
import {CourseRosterIpService} from "../../../../shared/course-roster-ip.service";

@Component({
    selector: 'app-roster-grad-submit-status',
    templateUrl: './ip-grade-submit-status-component.html',
    styleUrls: ['./ip-grade-submit-status-component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class IpGradeSubmitStatusComponent implements OnInit, OnDestroy {
    private intervalTime: number = 350;

    constructor(
        public dialogRef: MatDialogRef<IpGradeSubmitStatusComponent>,
        public courseRosterIPService: CourseRosterIpService,
        public gradeValidationService: GradeValidationService,
        @Inject(MAT_DIALOG_DATA) public data: Array<IPCourseSubmit>
    ) {}

    returnResultData: Array<String> = [];
    intervalPostGradeStatus: number;
    validationStatusList: Array<IPGradeValidationStatus> =[];

    //local variables that is needed
    ngOnInit(): void {
        this.returnResultData.splice(0);
        this.setValidationStatus();
        this.submitGrade();
    }

    clearInterval(): void {
        if (this.intervalPostGradeStatus) {
            clearInterval(this.intervalPostGradeStatus);
        }
    }

    ngOnDestroy(): void {
        this.clearInterval();
    }

    setValidationStatus() {
        this.validationStatusList.splice(0);
        this.data.forEach((item: IPCourseSubmit) => {
            const tempData: IPGradeValidationStatus = {
                course: item,
                gradeValidationStatus: {
                    transactionId: item.transactionId,
                    totalCount: 0,
                    currentCount: 0
                },
                list: []
            };
            this.validationStatusList.push(tempData);
        });
    }

    getValidationStatus() {
        this.validationStatusList.forEach((status: IPGradeValidationStatus) => {
            this.gradeValidationService
                .getByRosterPostStatus(status.course.transactionId)
                .subscribe((response: GradeValidationStatus) => {
                    console.log(response);
                    status.gradeValidationStatus = response;
                });
        });
    }

    submitGrade() {
        this.returnResultData.splice(0);

        this.intervalPostGradeStatus = setInterval(() => {
            this.getValidationStatus();
        }, this.intervalTime);

        this.courseRosterIPService.save(this.data).subscribe((result: IPStudentGradeValidationError) => {
            result?.postGradeResult?.forEach((item: StudentGradeValidationError) => {
                console.log(item);
                console.log(this.data);
                const submitCourseData = this.data.find((courseData: IPCourseSubmit) => {
                    return courseData.transactionId == item.iGradeTransactionId;
                });


                if(submitCourseData){
                    if (item.gradePostComplete.toUpperCase() === 'N') {
                        switch (item.errorCode.toUpperCase()) {
                            case 'N': {
                                this.returnResultData.push(
                                    'Unable to submit grade.  Banner error please see validation log.'
                                );
                                break;
                            }
                            case 'S': {
                                this.returnResultData.push('Unable to submit grade. \nNo grade change.');
                                break;
                            }

                            default: {
                                this.returnResultData.push('Unable to submit grade.');
                                break;
                            }
                        }

                        item?.rows.forEach(function (value: StudentGradeValidation) {
                            //find the student record and update the status code and message
                            submitCourseData.studentList.find((student: Student) => {
                                if (student.studentId == value.studentId) {
                                    student.gradeValidationCode = value.status;
                                    student.gradeValidationDescription = value.description;
                                }
                            });
                        });
                    } else {
                        const courseString =
                            submitCourseData.termCodeDescription +
                            ' - ' +
                            submitCourseData.subjectCode +
                            ' ' +
                            submitCourseData.courseNumber +
                            ' ' +
                            submitCourseData.sectionNumber +
                            ' (' +
                            submitCourseData.crn +
                            ')';
                        this.returnResultData.push('Grade has been submitted for ' + courseString + '.');
                    }
                }

            });
            this.onClose();
        });

    }

    getDetailData() {

        this.validationStatusList.forEach((status: IPGradeValidationStatus) => {
            //find course


            this.gradeValidationService
                .getPostStatusDetail(status.course.transactionId)
                .subscribe((response: GradeValidationStatusDetailList) => {
                    response?.list?.forEach(function (value: GradeValidationStatusDetail) {

                        status.course.studentList.find((item: Student) => {
                            if (item.studentId == value.studentId) {
                                item.gradeValidationCode = value.gradeValidationCode;
                                item.gradeValidationDescription = value.gradeValidationDescription;
                            }
                        });
                    });

                    this.gradeValidationService
                        .getPostCompleteDetail(status.course.transactionId)
                        .subscribe((response: GradePostCompleteStatus) => {
                            if (response.gradePostComplete.toUpperCase() === 'N') {
                                switch (response.errorCode.toUpperCase()) {
                                    case 'N': {
                                        this.returnResultData.push(
                                            'Unable to submit grade.  Banner error please see validation log.'
                                        );
                                        break;
                                    }
                                    case 'S': {
                                        this.returnResultData.push('Unable to submit grade. \nNo grade change.');
                                        break;
                                    }

                                    default: {
                                        this.returnResultData.push('Unable to submit grade.');
                                        break;
                                    }
                                }
                            } else {
                                this.returnResultData.push('Grades have been submitted.');
                            }
                        });

                    this.onClose();
                });
        });
    }

    gradePostComplete() {
        this.getDetailData();
    }

    onClose() {
        this.clearInterval();
        this.dialogRef.close(this.returnResultData);
    }
}
